import LocalizedStrings from 'react-localization';

/** Booking lost-reason value for data deletion; must match backend Constants.CustomerLostReasons.DataDeletionLostReason. */
export const CUSTOMER_LOST_REASON_DATA_DELETION = 'Data deletion';

const germanToEnglish = {
  'Besitzt bereits eine PV Anlage': 'Owns PV system',
  'Kein Eigentümer': 'Not an owner',
  // 'Dach über 3 Monate fertig': 'Roof over 3 months finished',
  'Kunde möchte nicht mehr kontaktiert werden': 'Customer does not want to be contacted again',
  'Sonstiges (bitte im Kommentar angeben)': 'Other (please specify in comment)',
  'Nicht mehr interessiert': 'Not interested anymore',
  'Möchte nicht an einem Videoanruf teilnehmen': 'Does not want to take part in a video call',
  'Konnte keinen passenden Termin finden': 'Could not find a suitable appointment',
  'Technisch nicht machbar': 'Technically not feasible',
  'Kein Wohnsitz': 'No residence',
  Duplikat: 'Duplicate',
  'Kein Wifi/Laptop': 'No wifi/laptop',
  'Haus ist vermietet': 'Place is rented out',
  Mehrfamilienhaus: 'Apartment building (Mehrfamilienhaus)',
  'Datenlöschung': CUSTOMER_LOST_REASON_DATA_DELETION,
};
const englishToGerman = Object.fromEntries(Object.entries(germanToEnglish).map(([key, value]) => [value, key]));

const actionsDe = {
  Booked: `Gebucht`,
  NotReached: 'Nicht erreicht',
  ReachedNotBooked: 'Erreicht, aber nicht gebucht',
  CustomerLost: 'Kunde verloren',
  RevisionQueueAssignment: 'An Revision gegeben',
  WrongPhoneNumber: 'Falsche Telefonnummer',
  AppointmentHappened: 'Termin hat stattgefunden',
  Assignment: 'Zuweisung',
  WentOffline: 'Offline gegangen',
};

const actionsEn = {
  Booked: `Booked`,
  NotReached: 'Not reached',
  ReachedNotBooked: 'Reached, but not booked',
  CustomerLost: 'Customer lost',
  RevisionQueueAssignment: 'Revision queue assignment',
  WrongPhoneNumber: 'Wrong phone number',
  AppointmentHappened: 'Appointment happened',
  Assignment: 'Assignment',
  WentOffline: 'Went Offline',
};

const customerLostShareContactDataOptionsEnToDe = {
  'Permission given': true,
  'Permission NOT given': false,
};
const customerLostShareContactDataOptionsDeToEn = {
  'Kontaktweitergabe genehmigt': true,
  'Kontaktweitergabe NICHT genehmigt': false,
};

export const strings = new LocalizedStrings({
  en: {
    notBookedReasonPlaceholder: 'Please add the reason why no appointment could be booked (min. 30 characters)',
    availability: 'Availability',
    activeIndicator: 'Active',
    inactiveIndicator: 'Inactive',
    startCall: 'Start call',
    powerHour: {
      title: 'Live Ship Race (Power Hour)',
      description: 'The team that collects the most XP per active person during the Power Hour wins. A person counts as active if they were online in BookingOS during the Power Hour.',
      descriptionNote: 'Note: To keep the ship race fair, XP from past appointments (i.e. when customers showed up to an appointment) do not count toward the Power Hour result.',
      powerHourEnded: 'The power hour has ended! Open the profile page to view the results',
      viewResults: 'View Results',
      powerHourStarted: 'Power Hour started - collect the most XP as a team to win!',
      remainingTime: 'Remaining time: ',
      liveResults: 'View Live Results',
      reloadButtonHint: 'Next update in',
      powerHourComplete: 'Power Hour Complete',
    },
    gamificationSettings: {
      title: 'Gamification settings',
      description: 'Configure how users earn XP, unlock achievements, and participate in Power Hour. Users receive XP after customer assignments and bookings, while achievements recognise milestones such as completing a first booking or reaching a booking target. Power Hour is a timed team competition for the most qualifying XP per active participant.',
      experiencePointsTab: '↑ Experience points',
      achievementsTab: '★ Achievements',
      powerHourTab: '◷ Power Hour',
      about: 'ⓘ About this setting',
      whatYouCanChange: 'What you can change:',
      whatUsersExperience: 'What users experience:',
      important: 'Important:',
      timezone: 'Timezone:',
      saveChanges: 'Save Changes',
      updateSuccess: 'Successfully updated!',
      updateFailed: 'Failed to update!',
      experiencePoints: {
        whatYouCanChange: 'Set the XP awarded for each tracked booking action.',
        whatUsersExperience: 'Users see XP in activity notifications, profile progression, levels, and XP leaderboards. Changes apply to future scoring and do not recalculate historical activity.',
        note: '“AppointmentHappened” points are not tracked for Field Sales bookings.',
      },
      achievements: {
        whatYouCanChange: 'Create, edit, or delete achievement rules, rewards, names, descriptions, icons, and eligibility criteria.',
        whatUsersExperience: 'Eligible users see progress and unlocked badges in their profile, and receive an unlock notification and the configured XP when rules are met.',
        add: 'Add achievement', addDescription: 'Create a new achievement rule.', deleteFailed: 'Failed to delete achievement', edit: 'Edit', delete: 'Delete',
        deleteConfirmationTitle: 'Are you sure you want to delete this achievement?', deleteConfirmationDescription: 'This action cannot be undone.', yes: 'Yes', no: 'No',
        iconAlt: 'achievement icon', iconPlaceholderAlt: 'achievement icon placeholder', name: 'Name', namePlaceholder: 'Achievement title', description: 'Description', descriptionPlaceholder: 'Achievement description', points: 'Points', target: 'Required number of actions', targetPlaceholder: 'Target', actions: 'Required actions', actionsHelp: 'Select actions which will be counted towards achievement progress', days: 'Days of the week', daysHelp: 'Specify during which days of the week the achievement is active', timeFrame: 'Time frame', timeFrameHelp: 'Specify time frame when achievement progress is tracked', deadline: 'Deadline', deadlineHelp: 'Specify when achievement should become inactive', accumulative: 'Accumulative', accumulativeHelp: 'If checked, progress will be accumulated over time', icon: 'Icon', upload: 'Upload', failedToReadFile: 'Failed to read file', invalidImageDimensions: 'Image must be exactly 100x100 pixels!', failedToLoadImage: 'Failed to load image.', invalidImageType: 'is not a png file', cancel: 'Cancel',
        daysOfWeek: { sunday: 'Sunday', monday: 'Monday', tuesday: 'Tuesday', wednesday: 'Wednesday', thursday: 'Thursday', friday: 'Friday', saturday: 'Saturday' },
      },
      powerHour: {
        whatYouCanChange: 'Schedule the day and time windows for the team competition.',
        whatUsersExperience: 'During an active Power Hour, users see campaign status messaging and compete as teams for the most qualifying XP per active participant.',
        timezoneNote: 'Times are displayed in Europe/Berlin and stored as UTC.',
        validationError: 'Validation Error', validationDescription: 'Please ensure all fields are filled out correctly.', saveSuccess: 'Success', saveSuccessDescription: 'Power Hour Configs saved successfully.', saveError: 'Error', saveErrorDescription: 'Failed to save Power Hour Configs.', addWindow: 'Add Power Hour window', addWindowDescription: 'Schedule a new team competition window.', fromDay: 'From Day', untilDay: 'Until Day', startTime: 'Start Time', endTime: 'End Time', delete: 'Delete',
      },
    },
    autodialerSettings: {
      title: 'Autodialer settings',
      description: 'Manage bucket configurations and phone-number rules for the Noetica autodialer.',
      bucketConfigTab: 'Bucket Config',
      phoneNumberSettingsTab: 'Phone Number Settings',
      bucketConfig: {
        title: 'Autodialer Bucket Configurations', addBucket: 'Add Bucket', editBucket: 'Edit Bucket',
        name: 'Name', description: 'Description', bucketName: 'Bucket Name', bucketId: 'Autodialer Bucket ID',
        salesChannels: 'Sales Channels', priorities: 'Priorities', frequency: 'Frequency', uploadFrequency: 'Upload Frequency',
        opportunityStatus: 'Opportunity Status', active: 'Active', inactive: 'Inactive', lastModified: 'Last Modified', actions: 'Actions',
        edit: 'Edit', delete: 'Delete', deleteBucket: 'Delete this bucket?', deleteWarning: 'This action cannot be undone.',
        cancel: 'Cancel', save: 'Save', selectSalesChannels: 'Select sales channels', selectPriorities: 'Select priorities', notSelected: 'Not selected',
        nameRequired: 'Name is required', bucketIdRequired: 'Autodialer Bucket ID is required', bucketNameRequired: 'Autodialer Bucket Name is required',
        salesChannelsRequired: 'At least one sales channel is required', prioritiesRequired: 'At least one priority is required',
        loadFailed: 'Failed to load autodialer buckets', saveFailed: 'Save failed', createFailed: 'Create failed', deleteFailed: 'Delete failed',
        serverError: 'Server returned an error.', validationError: 'Validation error', bucketUpdated: 'Bucket updated', bucketCreated: 'Bucket created', bucketDeleted: 'Bucket deleted',
        none: 'None', hourly: 'Hourly', realTime: 'Real Time', manual: 'Manual', firstTimeScheduling: 'First Time Scheduling', reschedulingNeeded: 'Rescheduling Needed',
      },
      phoneNumberSettings: {
        title: 'Phone Number Settings', loadFailed: 'Failed to load phone number settings', loadError: 'Could not load settings. Check administrator permissions and the API response.',
        emptyCliList: 'The outbound caller number list is empty — check the NoeticaAutodialAdminConfig database row and confirm that migration 122 has been applied.',
        invalidCallerNumber: 'Invalid caller number', invalidBlocked: 'Invalid blocked number', saveFailed: 'Save failed', serverError: 'Server returned an error.', saved: 'Phone number settings saved',
        invalidCallerNumberDescription: (line: number, value: string) => `Line ${line}: only digits and an optional leading + are allowed (example: +4917012345678). Got: "${value}"`,
        invalidBlockedDescription: (line: number, value: string) => `Line ${line}: only digits, +, -, (, and ) are allowed (example: +49(170)1234567). Got: "${value}"`,
        description: 'Configure which numbers appear when customers are called, and which numbers the autodialer should never dial.',
        lastUpdated: 'Last modified at', modifiedBy: 'by',
        callerNumbers: 'Outbound caller numbers',
        callerNumbersDescription: 'The number shown to the customer when they receive a call. The autodialer cycles through this list in order, one number per customer sent to Noetica. Each line must be digits only with an optional leading +.',
        blockedNumbers: 'Numbers to never call',
        blockedNumbersDescription: 'These numbers will never be dialled, even if they appear on a customer record. Each line may contain digits, +, -, and parentheses. Matching uses digits only after normalization, so a partial prefix like +49 will also block any number that starts with those digits. Numbers with five or more consecutive identical digits are also automatically blocked.',
        entries: (count: number) => `${count} entries`,
        placeholder: 'Numbers from the database appear here after load…', save: 'Save Changes',
      },
    },
    reporting: {
      selectTeamBtn: 'Select a Team',
      selectAgentBtn: 'Select an Agent',
      ratingAssignmentPerHour: 'Assignments/Hour',
      ratingBookings: 'Bookings',
      ratingBookingsPerHour: 'Bookings/Hour',
      ratingSameNextDayBookings: 'Same/Next Day Bookings (in %)',
      lblPerformanceTrends: 'Calls per agent and hour',
      lblDepView: 'Department View',
      lblTeamView: 'Team View',
      clarification: {
        assignments: 'Assignments are the number of customers assigned to a booker',
        assignmentsPerHour: 'Assignments per hour are the number of customers assigned to a booker per hour. Inbound Center bookings and assignments are not considered for this metric.',
        bookings: 'Bookings are the number of customers that have booked an appointment',
        bookingsPerHour: 'Bookings per hour are the number of customers that have booked an appointment per hour. Inbound Center bookings and assignments are not considered for this metric.',
        nearestAppointmentsPerToday: 'The percentage of customers that have booked an appointment for today or tomorrow',
      },
      viewSwitch: {
        teamView: 'Switch to Team View',
        individualView: 'Switch to Individual View',
      },
      periodSwitch: {
        daily: 'Switch to Daily View',
        monthly: 'Switch to Monthly View',
      },
    },

    inboundCenter: {
      assignmentExistsWarning: 'Assignment not possible. Please complete the customer assigned to you first or go offline to continue.',
      assignmentExistsButton: 'To the assigned customer',
    },

    missingUserProfile: 'You have not yet processed your first customer. Please process your first customer to see this page.',
    profileRemainingXpTillNextLvl: 'Remaining XP till next level:',
    profileTopExperience: 'Leaderboard',
    profileExpHover: `Booking successful - 10 XP
    Not reached - 1 XP
    Reached, but not booked - 2 XP
    Customer lost - 2 XP
    Revision queue assignment - 2 XP
    Wrong phone number - 2 XP`,
    getActionName: (action: keyof typeof actionsEn) => {
      return actionsEn[action];
    },

    reportingActivity: 'Activity',
    reportingLeadTime: '% Same-/Next-Day Bookings',
    reportingReachedRate: 'Reached',
    reportingBookings: 'Bookings',
    reportingBookingRate: 'Booking Rate',
    reportingShowRate: 'Show Rate',
    reportingNettermine: 'Nettotermine',
    reportingVsYesterday: 'v.s. yesterday',
    reportingVsLastMonth: 'v.s. last month',
    reportingCallPerHour: 'Assignments per Hour Today',
    reportingCallPerDay: 'Assignments per Day',
    reportingCallPerDayPast: 'Assignments per Day last Month',
    reportingCallPerHourPast: "Yesterday's Assignments per Hour",
    reportingTopBookersToday: 'Top Bookers Today',
    reportingTopCallersToday: 'Top % Same-/Next-Day Bookings Today',
    reportingHighestBookingRateToday: 'Most Bookings per Assignment Today (in %)',
    reportingShowRateLeaderboard: 'Show Rate for Today (in %)',
    reportingComparedToSameTimeYesterday: 'Compared to same time yesterday',
    reportingComparedToSameTimeLastMonth: 'Compared to same time last month',
    reportingYourPosition: 'Your Position',
    reportingWarningMessage: 'You have already given more than 3 assigned customers back into the queue without editing them this hour',
    reportingNextUpdateAt: 'Next update at',
    reportingNoAppointmentsToday: 'No appointments today',
    reportingAppointmentsToGo: 'Appointments to go',
    reportingAppointmentsConsidered: 'Appointments considered',
    reportingShowRateClarification: 'There should be at least 3 appointments for the day that already happened to calculate the show rate',
    reportingNotificationCustomerShowed: 'Congrats! Your booked appointment just took place!',
    reportingNotificationCustomerShowedFunc: (slotStartTime: string | undefined, whenBooked: string | null | undefined) => {
      if (!slotStartTime) {
        return 'Congrats! Your booked appointment just took place!';
      }
      return `Congrats! Your booked appointment took place on ${slotStartTime}${whenBooked ? ` and was booked on ${whenBooked}` : ''}`;
    },

    reportingNotificationCustomerShowedTitle: 'Customer showed up!',
    reportingNotificationActionTitle: 'XP gained!',
    reportingNotificationLevelUp: (level: string | undefined, levelName: string) => {
      return `You have reached the level ${level} ${levelName}`;
    },
    reportingNotificationAchievementTitle: 'Achievement unlocked!',
    reportingNotificationAchievement: (name: string, points: string) => {
      return `You received '${name}' achievement. ${points} XP gained!`;
    },

    planningOnHoldTag: 'Planning On Hold',
    customerPortalCancellation: 'Customer cancelled via Inbound or SST',
    planningOnHoldExplanation:
      'Planning for this customer could not yet be completed, likely because the house could not be found via Google Maps. The customer should have received an e-mail from the planning department to provide additional details, such as building plans of their house.',
    lostReason: (reason: string) => {
      return reason;
    },
    inboundCallBack: {
      success: 'Your changes have been saved successfully',
      failure: 'There was an error while saving your changes. Please try again.',
    },
    cancelAppointment: 'Cancel Appointment',
    cancelModal: {
      text: 'You are about to cancel this appointment. This cannot be undone. Are you sure you want to continue?',
      rescheduleInstead: 'Reschedule Instead',
      confirmCancellation: 'Confirm Cancellation',
    },
    reschedule: 'Reschedule',
    assignToMeAndOpen: 'Assign to me & Open',
    attention: (email: string) => `Caution: This customer is currently assigned to ${email} and will be called shortly`,
    lastAppointment: (date: string, time: string, salesManager: string) => `Initial appointment on ${date} at ${time} with ${salesManager}`,
    wrongPhoneNumber: {
      title: 'Wrong Phone Number',
      prompt: 'Please specify what is wrong about the phone number',
      cancel: 'Cancel',
      saveAndOpenNextCase: 'Save & Open Next Case',
      saveAndCompleteCase: 'Save & Complete Case',
      pleaseSpecifyReason: 'Please specify a reason',
      buttonClarification: 'Please specify a reason to proceed',
      characterLimitReached: '⚠️ Character limit reached (2000/2000)',
      reasons: ['Number looks invalid (e.g. 000000000 or 123456789)', 'No connection under this number', 'Wrong Person (e.g. did not know about Enpal)', 'Other (please specify in comment)'],
    },

    updateWrongPhoneNumber: {
      body: 'This contact has provided a new phone number. Please try contacting them via the new number to continue.',
      cancel: 'Cancel',
      updateWithNewNumber: 'New Number Is Correct',
      updateWithnewNumberTooltip: 'The number will be updated and you will return to the booking mask.',
      newNumberIncorrect: 'New Number Is Also Wrong',
      actionIsDisabled: 'Please call the new number to proceed',
    },
    salesAgentManagement: {
      department: 'Department',
      failedToLoad: 'Failed to load sales agents',
      modalTitle: 'Sales Agent Calendar',
      refresh: 'Refresh',
      searchPlaceholder: 'Search by Name',
      tableColumns: {
        id: 'ID',
        name: 'Name',
        salesChannel: 'Sales Channel',
        department: 'Department',
        salesLeague: 'Sales League',
        zipCodes: 'Zip Codes',
        lastModified: 'Last Modified',
        productType: 'Product Type',
        paymentModel: 'Payment Model',
        status: 'Status',
      },
      title: 'Sales Agents Management',
      viewInCrm: (crm: string) => `View in ${crm}`,
      viewSlots: 'View Slots',
    },

    searchPlaceholder: 'Search by Name, Last Name, Phone number, e-mail or ID',

    signedupPeriod: {
      today: 'Today',
      yesterday: 'Yesterday',
      daysAgo: 'Signed up {0} days ago',
      weeksAgo: 'Signed up {0} weeks ago',
      monthsAgo: 'Signed up {0} months ago',
      moreThan3MonthsAgo: 'Signed up more than 3 months ago',
    },

    lostPeriod: {
      today: 'Lost today',
      yesterday: 'Lost yesterday',
      daysAgo: 'Lost {0} days ago',
      weeksAgo: 'Lost {0} weeks ago',
      monthsAgo: 'Lost {0} months ago',
      moreThan3MonthsAgo: 'Lost more than 3 months ago',
    },

    recordingInProgress: 'Recording in progress. The recording will be deleted automatically if the customer is not reached.',
    nonStandardSlots: 'Non-standard slots',
    Mo: 'Mo',
    Tu: 'Tu',
    We: 'We',
    Th: 'Th',
    Fr: 'Fr',
    Sa: 'Sa',
    followingSlotWillBeBooked: 'The following slot will be booked',
    date: 'Date',
    startTime: 'Start Time',
    endTime: 'End Time',
    wouldYouLikeToProceed: 'Would you like to proceed?',
    errorOccurred: 'An error has occurred.',
    close: 'Close',
    bookingSuccessful: 'Booking successful!',
    salesManager: 'Sales Manager',
    youCanCloseThisWindow: 'You can now close this window.',
    errorCode: 'Error code',
    cancel: 'Cancel',
    confirm: 'Confirm',
    noSlotsAvailable: 'No slots available on this week',
    errorLoadingSlots: 'Error loading slots',
    calendarInitialLoadRetry: 'The new lead is still being synchronized. Retrying the calendar in 5 seconds ({0}/{1}).',
    tryAgain: 'Try again',
    dontCloseModal: 'Do not close or refresh the page while loading',
    customerCannotBeBooked:
      "Please check whether this customer already has an appointment booked. If not, use the old 'Schedule Sales Call' button in Salesforce for this customer and report the case to your team lead.",
    maximEventCountLabel: 'Maximum possible events for booking, considering max appointments per day per seller',
    totalEventCountLabel: 'Total bookable events, no cap',
    totalBookedEventCountLabel: 'Total booked events for the day',
    from: 'From',
    to: 'To',
    showLogs: 'Show Logs',
    fromLargerThanTo: 'From cannot be larger than To',
    searchMax3Days: 'You can only search in a span of 3 days',
    UnauthorizedAccess: 'You are not authorized to access this page',
    team: 'Team',
    reason: 'Reason',
    customerTier: 'Customer Tier',
    result: 'Result',
    status: 'Status',
    rebook: 'Rebook',
    time: 'Time',
    products: 'Products',

    sellerLanguage: 'Seller Language',
    English: 'English',
    German: 'German',
    referredBy: 'Refeferred by',
    paymentModel: 'Payment model',

    SCHEDULING_CASE_NOT_FOUND: "This customer cannot be booked, please contact support. Error details: 'Scheduling Case not found'",
    NO_SLOTS_AVAILABLE: 'This slot is no longer available. Please try with a different time slot.',

    selectAtLeastOneReason: 'Select one reason',
    loadCalendar: 'Load Calendar',
    startBooking: 'Start Booking',
    leadQueueQualification: {
      instructions: 'Please ask the customer the following questions to proceed to the calendar:',
      next: 'Next',
      questionCounter: 'Question {current} of {total}',
    },
    opportunityCommentsPlaceholder: 'Please insert your comments here. They will be automatically saved when the case is closed.',
    opportunityCommentsError: 'Too many characters',
    saveAndOpenNextCase: 'Save & Open Next Case',
    openNextCase: 'Open Next Case',
    back: 'Back',
    backToInboundCenter: 'Back to Inbound Center',
    modalTextLoadingNextCustomer: 'Loading next customer, hang tight...',
    modalTitleReachedNotBooked: 'Reached, But Not Booked',
    modalTextReachedNotBookedHoursInAdvance: 'Please select the minimum number of hours we should wait before calling the customer again',
    modalTitleCustomerLost: 'Give to Revision',
    looseCustomerButton: 'Customer Lost',
    completeCaseButton: 'Close Case',
    completeCaseModalTitle: 'Close Case',
    completeCaseModalText:
      'You are about to close this case. Select the reason that best describes why a sales conversation is not possible at this time.',
    modalTitleNotReached: 'Not Reached',
    modalTextNotReached: 'This action will snooze the current case and open the next case',
    notReachedButton: 'Not Reached',
    mailboxButton: 'Mailbox',
    noMailboxButton: 'No Mailbox',
    modalTextSelectNewTime: 'Or select the approximate time when the customer will next be available:',
    modalTextCustomerLostRevision: 'Note: Your are about to set this customer to lost. Please select one reason why a sales call with the customer is currently not possible',
    modalTextCustomerLost: 'Note: You are about to give the customer to the revision team.  Please select one reason why a sales call with the customer is currently not possible',
    customerLostOptions: Object.entries(germanToEnglish).map(([nameOfProp, propValue]) => ({
      value: propValue,
      label: propValue,
    })),
    customerLostPlaceholder: 'Please add your comments here...',
    customerLostUpTo3OptionsError: 'You can only select one reason',
    customerLostAtLeastOneOptionError: 'Please select one reason',
    customerLostTooManyCharactersError: 'No more than 255 characters allowed.',
    customerLostNoCharactersError: 'Description of why the customer was lost is required.',

    goOnline: 'Go Online',
    goOffline: 'Go Offline',
    goOfflineModalText: 'This will discard any changes you have made to the current case and re-assign it to a different booking agent. Are you sure you want to proceed?',
    goOnlineModalText: 'You are about to get a case assigned. Are you sure you want to proceed?',

    coundownRefreshError: 'Can only refresh the case assignment duration when it has less than 8 minutes remaining',
    countdownRefreshTooltip: 'Refresh the case assignment duration',
    countdownLessThanAMinuteTitle: 'Less than 1 minute remaining on this case',
    countdownLessThanAMinuteDescription: 'You will automatically be unassigned from this case when the timer runs out. Please refresh the timer via the provided button if you need more time.',
    salesScript: 'Sales Script',
    objections: 'Objections',
    appointmentDetails: 'Appointment Details',
    openingNextCaseIn: 'Opening next case in {0}',
    youAreOffline: 'You are offline',
    goBackOnlineToReceiveCase: 'Please go back online to receive a new case',
    autodialerMissingId: 'No opportunity id provided. Use a link with id=internalOppId.',
    autodialerAssignFailed: 'Could not assign this case.',
    autodialerAssignmentExistsOtherCase:
      'You are already assigned to a different case. Finish or release that case on the booking page, then open this autodialer link again.',
    autodialerCaseNotFound: 'No case found for this link. Ensure the id is the Booking OS internal id (from Noetica BOSinternalId), and that the opportunity exists in this environment.',
    autodialerNotAutodialedCase: 'This case is not currently in an autodialer list. The autodialer link can only assign opportunities that are marked as autodialed.',
    autodialerNotInAutodialer: 'This customer is no longer in the autodialer. Please reach out to your Booking Manager.',
    autodialerCaseComplete: 'Done',
    assignmentConflict: {
      title: 'You are already assigned to a customer',
      body: 'You are still assigned to {0}. This is a different customer than the one you just opened.',
      newCustomerNote: 'If you switch to the new customer, the current customer will be released.',
      keepOldButton: 'Keep current customer',
      switchNewButton: 'Switch to new customer',
      oldCompletedNotReached: 'The previous customer was released.',
      completeOldFailed: 'Could not release the previous customer. Please try again.',
      thisCustomer: 'the current customer',
    },
    assignmentChanged: {
      title: 'Your assignment has changed',
      body: 'This customer is no longer assigned to you. Refresh the page before continuing.',
      refreshButton: 'Refresh page',
    },
    autodialerHpMissingCrmId: 'No CRM id provided. Use a link with crmId.',
    autodialerHpLoadFailed: 'Could not load Autodialer HP information for this deal.',
    autodialerHpForbidden: "You don't have permission to load this deal. Please contact BookingOS administrator to add you to required entra role.",

    offlinePageTitle: 'You are offline',
    offlinePageContent: 'Please go back online to receive a new case.',

    onlinePageNoCasesTitle: 'There are no cases at the moment',
    onlinePageNoCasesContent: 'Re-trying in ',
    onlinePageNoCaesFetchingNewCase: 'Fetching a new case..',
    onlinePageNoCasesPleaseDoNotClose: 'Please do not close this page.',
    onlinePageNoCasesSeconds: ' seconds',

    caseCommentsBtn: (count: number) => `Show ${count} previous comments`,
    caseCommentsModalTitle: 'Previous Comments',
    customerInfoCaseCopied: 'Case copied to clipboard',
    customerInfoFailedToCopy: 'Failed to copy case to clipboard',

    share: 'Share',
    edit: 'Edit',

    cancelCountdown: 'Cancel Countdown',
    toolTipReferrer: 'This sales agent was recommended by an existing Enpal customer. The new customer receives a sales appointment with the same sales agent as the referrer, if possible',
    toolTipProductType: 'This is the product and financing type selected for the customer. The customer will receive an appointment with a sales agent who is trained to sell all selected products.',
    toolTipReactivatedCustomer: 'This customer was reactivated as part of an internal campaign.',
    tooltipCrmKunde:
      'Dieser Kunde wurde kürzlich per Nachricht (E-Mail, SMS, o.ä.) von Enpal kontaktiert und hat das Interesse an einer Enpal Energielösung bestätigt. Möglicherweise war er/sie schon einmal bei uns im Verkaufsprozess.',
    reactivatedCustomer: 'Reactivated Customer',

    caseCompleteNotification: 'You have been assigned to a new case',
    caseNotFoundErrorDescription: 'This case is no longer available. The customer may have been processed outside BookingOS or booked an appointment themselves.',
    youCanGetANewCase: 'You can get a new case by clicking the button below.',
    genericCloseCaseErrorDescription: 'An error has ocurred when closing this case. This error has been logged.',
    getNewCase: 'Get New Case',

    voiceMailHint: "If you don't reach the customer, please leave a voice message",

    assignNewCaseError: 'Assigning a new case unsuccessful. Please try again.',

    bookingStatus: (status: string) => {
      return status === 'FirstTimeScheduling' || status === 'First Time Scheduling' ? 'First Time Scheduling' : 'Rescheduling Needed';
    },
    salesChannelDropdownLabel: 'Choose your sales channel:',

    noOpportunityInCalendarTitle: 'Customer Not Found',
    noOpportunityInCalendarMessage:
      'Bookings for this opportunity will fail since it is either closed or already in a different step of the sales funnel. Please ensure the opportunity is open and in the scheduling stage in Salesforce.',

    customerLostShareDataPlaceholder: 'Did the customer agree to share their contact details?',
    customerLostShareDataEntries: Object.entries(customerLostShareContactDataOptionsEnToDe).map(([nameOfProp, propValue]) => ({
      value: propValue,
      label: nameOfProp,
    })),
    customerLostShareDataLabel: 'Please ask the customer whether they give consent to share their contact details with an Enpal partner.',
    customerLostShareDataTooltip: `This customer can likely be served by an Enpal partner. By giving their consent, customers allow us to connect them with a partner. Please ensure to also record the customer's response in Talkdesk`,
    customerLostShareDataNoOptionError: 'Please specify whether the customer agreed to share their contact details',

    adBookingPage: {
      caseIdLabel: 'BookingOS case ID',
      signupIdLabel: 'Signup ID',
      caseNotFound: 'This case was not found.',
      caseAccessDenied: 'You do not have access to this case.',
      caseLoadError: 'The case could not be loaded.',
      questionnaireLoadError: 'The questionnaire could not be loaded.',
      missingCaseId: 'The BookingOS case ID is missing from this link.',
      assignmentExtendError: 'The assignment could not be extended.',
      caseReleaseError: 'The case could not be released.',
      caseCloseError: 'The case could not be closed.',
      caseReloadError: 'The case could not be reloaded.',
      currentCaseCompletionError: 'The current case could not be completed. It remains assigned to you.',
      caseSwitchError: 'The case could not be switched.',
      noConfirmedBooking: 'No confirmed booking is available to complete.',
      completionError: 'Case completion failed. Retry completion; the Zeeg booking is already confirmed.',
      completionRetryError: 'Case completion could not be retried.',
      zeegAvailabilityError: 'Zeeg availability could not be loaded.',
      caseNotLoaded: 'The case is not loaded.',
      savedFormLoadError: 'The saved form could not be loaded.',
      savedFormRetryDescription: 'The case remains assigned to you. Please retry if the form is still unavailable.',
      bookingCompleted: 'Appointment booked and case completed.',
      cancellationCompleted: 'Customer cancelled and case completed.',
      confirmCancellationDescription: 'Review the cancellation reason and confirm to close this case.',
      notReachedCompleted: 'Not reached recorded and case completed.',
      reachedNotBookedCompleted: 'Reached but not booked recorded and case completed.',
      canClosePage: 'You can now close this page.',
      keepPageOpen: 'Keep this page open and retry case completion. The appointment must not be booked again.',
      snoozeSummary: (minutes: number, until: string) => `Snoozed for ${minutes} minutes, until ${until} (Berlin time).`,
      completionPending: 'The Zeeg appointment is confirmed, but case completion is pending.',
      retryCompletionButton: 'Retry completion',
      videoBookingTitle: 'Book a video appointment',
      openCaseError: 'Failed to open the case',
      lostReasonsTitle: 'Objections & closing reasons',
      showMoreReasons: 'Show more',
      showLessReasons: 'Show less',
    },

    preSalesQuestionnaire: {
      cancellationTitle: 'CANCELLATION!',
      cancellationHeatLoadTitle: 'Cancellation / Heat load',
      noCancellation: 'No cancellation',
      cancellationDefaultDescription: 'The current answers block this form.',
      showCancellationReasons: 'Show cancellation reasons',
      noCancellationReasons: 'No cancellation reasons',
      cancellationCheckUnavailable: 'Cancellation check unavailable',
      cancellationReasonQuestionsIntro: 'The cancellation reasons are based on the answers to the following questions:',
      cancellationEvaluationError: 'Cancellation could not be evaluated. Change an answer or try again before submitting.',
      productOverviewTitle: 'Product overview',
      heatPumpShortLabel: 'HP',
      pvShortLabel: 'PV',
      productStatusNotInterested: 'Not interested',
      productStatusEligible: 'Eligible',
      productStatusPending: 'Pending qualification',
      productStatusNotEligible: 'Not eligible',
      showReasons: 'Show reasons',
      productCancellationReasonsTitle: (product: string) => `Cancellation reasons: ${product}`,
      questionnaireProgress: 'Questionnaire progress',
      questionnaireProgressSummary: (answered: number, total: number, percent: number) =>
        `${answered} of ${total} fields answered · ${percent}%`,
      dealInfoTitle: 'Deal info',
      dealIdLabel: 'Deal ID',
      hpOrderNumberLabel: 'HP Order Number',
      customerLabel: 'Customer',
      addressLabel: 'Address',
      emailLabel: 'Email',
      heatLoadLabel: 'Heat load',
      heatLoadReady: 'Heat load ready',
      heatLoadValid: 'Heat load is valid',
      heatLoadCancellation: 'Heat load cancellation',
      heatLoadProgressLabel: (percent: number) => `Heat load input completeness, ${percent}%`,
      showHeatLoadInformation: 'Show heat load information',
      showFaqInformation: 'Show FAQ information',
      saveButton: 'Save',
      saveSuccess: 'Pre-sales form saved',
      saveError: 'Failed to save pre-sales form',
      saveMissingIdentifier: 'Cannot save pre-sales form without a CRM id',
      submitButton: 'Submit',
      backToFormButton: 'Back to questionnaire',
      closeCaseButton: 'Close Case',
      closeCaseTooltip: 'Clicking this would close the questionnaire and stop the recording. You can reload the page to start again.',
      closeCaseSuccess: 'Case closed',
      submitSuccess: 'Pre-sales form submitted',
      submitError: 'Failed to submit pre-sales form',
      submitMissingIdentifier: 'Cannot submit pre-sales form without a CRM id',
      submitValidationError: 'Please complete the required pre-sales questions before submitting',
      pvQualifiedTitle: 'Continue with the Combi handover',
      pvQualifiedDescription: 'Confirming creates and forwards the PV lead for the combined PV and heat-pump offer. You will then choose an appointment.',
      pvOnlyQualifiedTitle: 'Continue with the PV handover',
      pvOnlyQualifiedDescription: 'Confirming creates and forwards the PV lead. You will then choose an appointment.',
      combiHandoverNextStep: 'Next: hand over to Combi',
      pvHandoverNextStep: 'Next: hand over to PV',
      pvQualifiedAbortDescription: 'If cancelled, TMVT will continue with the next question.',
      combiForwardButton: 'Continue to Combi handover',
      pvForwardButton: 'Continue to PV handover',
      pvDeclineButton: 'Cancel',
      pvConfigurationError: 'PV handover is not available',
      pvMissingSignupId: 'PV handover is not available because the current lead has no signup ID.',
      pvMissingGcId: 'PV handover is not available because the current customer has no GCID.',
      pvDisqualifiedTitle: 'PV Disqualified',
      pvDisqualifiedDescription: 'Unfortunately, we cannot offer the customer a PV system. Please continue with TMVT.',
      pvOnlyDisqualifiedDescription: 'Unfortunately, we cannot offer the customer a PV system. Because the customer is interested in PV only, submit the form normally to mark the Heat lead as lost.',
      pvContinueHeatButton: 'Confirm',
      pvForwardingError: 'PV handover failed',
      leadAlreadyHandedOver: 'The lead was successfully handed over. A booker will call the customer again to schedule the appointment.',
      pvHandoverMissingResult: 'Lead Handling did not return a signup ID for the new PV lead. Please retry the handover.',
      pvForwardingSuccessTitle: 'PV lead created',
      pvHandoverCalendarDescription: 'Choose a Digital Sales appointment for the new PV lead.',
      combiForwardingSuccessTitle: 'Combi handover ready',
      combiHandoverCalendarDescription: 'Choose a Digital Sales appointment for the new Combi lead.',
      pvBookingSuccessTitle: 'PV booking was successful',
      combiBookingSuccessTitle: 'Combi booking was successful',
      resultCancellationTitle: 'Cancellation',
      resultCancellationDescription: 'This customer cannot be served with a heat pump. The following cancellation reasons were returned:',
      resultCancellationNoReasons: 'This customer cannot be served with a heat pump. No specific cancellation reasons were returned.',
      resultBuildableTitle: 'No cancellation reasons found',
      fieldSalesChoiceQuestion: 'Does the customer want a Field Sales appointment?',
      fieldSalesMissingZipCode: 'Cannot load Field Sales calendar without a zip code',
      fieldSalesAvailabilityError: 'Failed to load Field Sales availability',
      fieldSalesAvailabilityChecking: 'Checking Field Sales availability…',
      fieldSalesChoiceUnavailable: 'Field Sales booking is not available for this customer.',
      fieldSalesCalendarTitle: 'Field Sales availability',
      fieldSalesUnavailable: 'No Field Sales agent available for this zip code',
      fieldSalesSlotsError: 'Failed to load Field Sales appointment slots',
      fieldSalesBookingError: 'Failed to book Field Sales appointment',
      fieldSalesBookingConfirmationError: 'The slot was booked, but the Field Sales booking could not be confirmed',
      fieldSalesConfirmationError: 'Failed to confirm Field Sales',
      fieldSalesConfirmationMissingDeal: 'Cannot confirm Field Sales without a deal id',
      fieldSalesBookingMissingData: 'Cannot book Field Sales appointment without a deal, zip code, and slot',
      fieldSalesBookingSuccess: 'Field Sales appointment booked',
      fieldSalesBookingSuccessTitle: 'Field Sales booking was successful',
      bookingConfirmationPending: 'An appointment already exists and still needs confirmation. Retry the same booking before changing the sales channel.',
      videoCalendarTitle: 'Video appointment slots',
      videoCalendarSwitchLabel: 'Calendar selection',
      videoCalendarSwitchDescription: 'Switch between the two appointment calendars.',
      videoPrimaryCalendarLabel: 'Primary calendar',
      videoDefaultCalendarLabel: 'Default calendar',
      videoPrimaryCalendarPosition: 'Primary · 1 / 2',
      videoDefaultCalendarPosition: 'Default · 2 / 2',
      videoSlotsError: 'Failed to load video appointment slots',
      videoSlotsEmpty: 'No video appointment slots available for this week',
      videoSlotBookButton: 'Book',
      videoSlotBookedButton: 'Booked',
      videoBookingSuccess: 'Video appointment booked',
      videoBookingSuccessTitle: 'SC1 booking was successful',
      videoBookingError: 'Failed to book video appointment',
      videoBookingConfirmationError: 'The Zeeg appointment was booked, but the deal could not be finalized as Video Sales',
      videoBookingMissingContact: 'Cannot book video appointment without customer name and email',
      videoBookingMissingDeal: 'Cannot book video appointment without a valid deal id',
      videoBookingConfigurationError: 'Video booking is unavailable because the Zeeg routing information is missing',
      whatsAppTipTitle: 'Tip for the customer',
      whatsAppTipDescription: 'For a smooth customer journey, we recommend allowing us to communicate via WhatsApp. To enable it, the customer only needs to click the link once in the confirmation email.',
      customerPortalTipTitle: 'Customer portal information',
      customerPortalTipDescription: 'Please let the customer know that the confirmation email includes an invitation to our customer portal. There, customers can:',
      customerPortalTipBenefits: [
        'View their upcoming appointments',
        'Track the consultation process',
        'Review their answers from this call',
      ],
      meetingUrlLabel: 'Meeting URL',
      bookingIdLabel: 'Booking ID',
      yesButton: 'Yes',
      noButton: 'No',
    },

    contactEditTitle: 'Edit Contact Data',
    contactEditCancel: 'Cancel',
    contactEditSave: 'Save',
    contactEditSalutation: 'Salutation',
    contactEditFirstName: 'First Name',
    contactEditLastName: 'Last Name',
    contactEditPhone: 'Phone Number',
    contactEditAddress: 'Adress',
    contactEditStreet: 'Street',
    contactEditHouseNumber: 'House Number',
    contactEditZipCode: 'Zipcode',
    contactEditCity: 'City',
    contactEditConvertToAreaCode: 'Add German Area Code (+49)',
    contactEditEditInSalesforce: 'Edit Address',
    contactEditNamesInSalesforce: 'Edit Name',
    customerLostDataDeletion: 'Data Deletion',
    customerLostConfirmEmailSent: 'I confirm that I have sent an e-mail to request data deletion',
    customerLostDataDeletionProceedToolTip: 'Please confirm that you have sent an e-mail to request data deletion.',
    customerLostDataDeletionButtonToolTip: `Generate an e-mail draft to the GDPR team for deleting this customer's data. You can edit the e-mail before sending it.`,

    customerJourneyPlanner: {
      summary: 'Configure how BookingOS handles leads.',
      ruleOrderHelp: 'How rule order works',
      ruleOrderHelpContent: 'Rules execute in alphabetical order. Prefix a rule name with a number to specify execution order.',
      moreActions: 'More actions',
      descriptionLine1: 'Change how leads are handled in BookingOS. Use rules to tailor qualification flows, scripts, booking behaviour, and other customer-facing actions. Rules execute in alphabetical order, so you can prefix the rule name with a number to specify execution order.',
      descriptionLine2: 'Hover the ⓘ next to a rule name to read its description.',
      filterOutcome: 'Outcome',
      filterCondition: 'Condition',
      filterSalesChannel: 'Sales Channel',
      outcomeOpportunitySync: 'Opp Sync',
      outcomeCalendarDisplay: 'Calendar Display',
      outcomeSlotBooking: 'Slot Booking',
      outcomeAgentsView: 'Scripts',
      filterPlaceholder: 'Outcome',
      filterByOutcome: 'Filter by outcome',
      filterBySalesChannel: 'Filter by sales channel',
      clearAll: 'Clear all',
      searchPlaceholder: 'Search rules, e.g. by lead source or seller Azure ID',
      searchTooltip: 'Search by rule name, condition, or outcome',
      addRuleLabel: 'New Rule',
      addRuleDescription: 'Create a condition-based rule to tailor how opportunities are handled.',
      exportRules: 'Export Rules',
      importRules: 'Import Rules',
      loadFailed: 'Failed to load customer rules',
      loadFailedDescription: 'Loading customer rules failed.',
      savedSuccessfully: 'Rule saved successfully',
      saveFailed: 'Failed to save rule',
      unknownError: 'Unknown error',
      edit: 'Edit',
      duplicate: 'Duplicate',
      delete: 'Delete',
      duplicateSuffix: 'COPY',
      ruleActions: 'Rule actions',
      resultsCount: '{count} out of {total} rules',
      noRulesMatched: 'No rules matched your search or filter.',
      by: 'By',
      modified: 'Modified',
      deleteConfirmTitle: 'Are you sure you want to delete this rule?',
      deleteConfirmContent: 'This action cannot be undone.',
      deleteConfirmOk: 'Yes',
      deleteConfirmCancel: 'No',
    },

    // 404 Page
    pageNotFound: {
      title: 'Page Not Found',
      message: 'The page you are looking for does not exist.',
      goToBooking: 'Go to Booking',
      errorCode: 'Error 404',
    },

    // Access Denied Page
    accessDenied: {
      title: 'Access Denied',
      message: "You don't have permission to access this page. Please contact your administrator if you believe this is an error.",
      goToBooking: 'Go to Booking',
    },
  },
  de: {
    notBookedReasonPlaceholder: 'Füge hier den Grund ein, warum kein Termin gebucht werden konnte (min. 30 Zeichen)',
    availability: 'Verfügbarkeit',
    activeIndicator: 'Aktiv',
    inactiveIndicator: 'Inaktiv',
    startCall: 'Anruf starten',
    powerHour: {
      title: 'Live Schiffsrennen (Power Hour)',
      description: 'Es gewinnt das Team, das pro aktiver Person die meisten XP während der Power Hour sammelt. Als aktiv zählt, wer in BookingOS während der Power Hour online war.',
      descriptionNote: 'Hinweis: Um das Schiffsrennen fair zu halten, zählen XP von vergangenen Terminen (d.h. wenn Kunden zum Termin auftauchen) nicht zum Power Hour Ergebnis',
      powerHourEnded: 'Die Power Hour ist vorbei! Öffne die Profilseite, um die Ergebnisse zu sehen',
      viewResults: 'Ergebnisse anzeigen',
      powerHourStarted: 'Power Hour gestartet - sammelt als Team die meisten XP, um zu gewinnen!',
      remainingTime: 'Verbleibende Zeit:',
      liveResults: 'Live Ergebnisse anzeigen',
      reloadButtonHint: 'Nächstes Update in',
      powerHourComplete: 'Die Power Hour ist vorbei',
    },
    gamificationSettings: {
      title: 'Gamification-Einstellungen',
      description: 'Lege fest, wie Nutzer XP sammeln, Erfolge freischalten und an der Power Hour teilnehmen. Nutzer erhalten XP nach Kundenzuweisungen und Buchungen, während Erfolge Meilensteine wie die erste abgeschlossene Buchung oder das Erreichen eines Buchungsziels würdigen. Die Power Hour ist ein zeitlich begrenzter Teamwettbewerb für die meisten qualifizierenden XP pro aktivem Teilnehmer.',
      experiencePointsTab: '↑ Erfahrungspunkte',
      achievementsTab: '★ Erfolge',
      powerHourTab: '◷ Power Hour',
      about: 'ⓘ Über diese Einstellung',
      whatYouCanChange: 'Was Du ändern kannst:',
      whatUsersExperience: 'So erleben Nutzer es:',
      important: 'Wichtig:',
      timezone: 'Zeitzone:',
      saveChanges: 'Änderungen speichern',
      updateSuccess: 'Erfolgreich aktualisiert!',
      updateFailed: 'Aktualisierung fehlgeschlagen!',
      experiencePoints: {
        whatYouCanChange: 'Lege die XP fest, die für jede erfasste Buchungsaktion vergeben werden.',
        whatUsersExperience: 'Nutzer sehen XP in Aktivitätsbenachrichtigungen, im Profilfortschritt, in Leveln und in XP-Ranglisten. Änderungen gelten für künftige Bewertungen und berechnen vergangene Aktivitäten nicht neu.',
        note: '„AppointmentHappened“-Punkte werden für Buchungen im Außendienst nicht erfasst.',
      },
      achievements: {
        whatYouCanChange: 'Erstelle, bearbeite oder lösche Erfolgsregeln, Belohnungen, Namen, Beschreibungen, Symbole und Teilnahmebedingungen.',
        whatUsersExperience: 'Berechtigte Nutzer sehen ihren Fortschritt und freigeschaltete Abzeichen im Profil und erhalten eine Freischaltbenachrichtigung sowie die konfigurierten XP, wenn die Regeln erfüllt sind.',
        add: 'Erfolg hinzufügen', addDescription: 'Erstelle eine neue Erfolgsregel.', deleteFailed: 'Erfolg konnte nicht gelöscht werden', edit: 'Bearbeiten', delete: 'Löschen',
        deleteConfirmationTitle: 'Möchtest Du diesen Erfolg wirklich löschen?', deleteConfirmationDescription: 'Diese Aktion kann nicht rückgängig gemacht werden.', yes: 'Ja', no: 'Nein',
        iconAlt: 'Erfolgssymbol', iconPlaceholderAlt: 'Platzhalter für Erfolgssymbol', name: 'Name', namePlaceholder: 'Titel des Erfolgs', description: 'Beschreibung', descriptionPlaceholder: 'Beschreibung des Erfolgs', points: 'Punkte', target: 'Erforderliche Anzahl an Aktionen', targetPlaceholder: 'Ziel', actions: 'Erforderliche Aktionen', actionsHelp: 'Wähle die Aktionen aus, die für den Fortschritt des Erfolgs gezählt werden.', days: 'Wochentage', daysHelp: 'Lege fest, an welchen Wochentagen der Erfolg aktiv ist.', timeFrame: 'Zeitfenster', timeFrameHelp: 'Lege fest, in welchem Zeitraum der Fortschritt des Erfolgs erfasst wird.', deadline: 'Frist', deadlineHelp: 'Lege fest, wann der Erfolg inaktiv werden soll.', accumulative: 'Kumulativ', accumulativeHelp: 'Wenn aktiviert, wird der Fortschritt im Laufe der Zeit angesammelt.', icon: 'Symbol', upload: 'Hochladen', failedToReadFile: 'Datei konnte nicht gelesen werden', invalidImageDimensions: 'Das Bild muss genau 100 × 100 Pixel groß sein!', failedToLoadImage: 'Bild konnte nicht geladen werden.', invalidImageType: 'ist keine PNG-Datei', cancel: 'Abbrechen',
        daysOfWeek: { sunday: 'Sonntag', monday: 'Montag', tuesday: 'Dienstag', wednesday: 'Mittwoch', thursday: 'Donnerstag', friday: 'Freitag', saturday: 'Samstag' },
      },
      powerHour: {
        whatYouCanChange: 'Plane die Tages- und Zeitfenster für den Teamwettbewerb.',
        whatUsersExperience: 'Während einer aktiven Power Hour sehen Nutzer Meldungen zum Kampagnenstatus und treten als Teams um die meisten qualifizierenden XP pro aktivem Teilnehmer an.',
        timezoneNote: 'Zeiten werden in Europa/Berlin angezeigt und in UTC gespeichert.',
        validationError: 'Validierungsfehler', validationDescription: 'Bitte stelle sicher, dass alle Felder korrekt ausgefüllt sind.', saveSuccess: 'Erfolgreich gespeichert', saveSuccessDescription: 'Die Power-Hour-Konfigurationen wurden erfolgreich gespeichert.', saveError: 'Fehler', saveErrorDescription: 'Die Power-Hour-Konfigurationen konnten nicht gespeichert werden.', addWindow: 'Power-Hour-Zeitfenster hinzufügen', addWindowDescription: 'Plane ein neues Zeitfenster für den Teamwettbewerb.', fromDay: 'Von Tag', untilDay: 'Bis Tag', startTime: 'Startzeit', endTime: 'Endzeit', delete: 'Löschen',
      },
    },
    autodialerSettings: {
      title: 'Autodialer-Einstellungen',
      description: 'Verwalte Bucket-Konfigurationen und Telefonnummernregeln für den Noetica-Autodialer.',
      bucketConfigTab: 'Bucket-Konfiguration',
      phoneNumberSettingsTab: 'Telefonnummern-Einstellungen',
      bucketConfig: {
        title: 'Autodialer-Bucket-Konfigurationen', addBucket: 'Bucket hinzufügen', editBucket: 'Bucket bearbeiten',
        name: 'Name', description: 'Beschreibung', bucketName: 'Bucket-Name', bucketId: 'Autodialer-Bucket-ID',
        salesChannels: 'Vertriebskanäle', priorities: 'Prioritäten', frequency: 'Frequenz', uploadFrequency: 'Upload-Frequenz',
        opportunityStatus: 'Opportunity-Status', active: 'Aktiv', inactive: 'Inaktiv', lastModified: 'Zuletzt geändert', actions: 'Aktionen',
        edit: 'Bearbeiten', delete: 'Löschen', deleteBucket: 'Diesen Bucket löschen?', deleteWarning: 'Diese Aktion kann nicht rückgängig gemacht werden.',
        cancel: 'Abbrechen', save: 'Speichern', selectSalesChannels: 'Vertriebskanäle auswählen', selectPriorities: 'Prioritäten auswählen', notSelected: 'Nicht ausgewählt',
        nameRequired: 'Name ist erforderlich', bucketIdRequired: 'Autodialer-Bucket-ID ist erforderlich', bucketNameRequired: 'Autodialer-Bucket-Name ist erforderlich',
        salesChannelsRequired: 'Mindestens ein Vertriebskanal ist erforderlich', prioritiesRequired: 'Mindestens eine Priorität ist erforderlich',
        loadFailed: 'Autodialer-Buckets konnten nicht geladen werden', saveFailed: 'Speichern fehlgeschlagen', createFailed: 'Erstellen fehlgeschlagen', deleteFailed: 'Löschen fehlgeschlagen',
        serverError: 'Der Server hat einen Fehler zurückgegeben.', validationError: 'Validierungsfehler', bucketUpdated: 'Bucket aktualisiert', bucketCreated: 'Bucket erstellt', bucketDeleted: 'Bucket gelöscht',
        none: 'Keine', hourly: 'Stündlich', realTime: 'Echtzeit', manual: 'Manuell', firstTimeScheduling: 'Erstterminierung', reschedulingNeeded: 'Neuplanung erforderlich',
      },
      phoneNumberSettings: {
        title: 'Telefonnummern-Einstellungen', loadFailed: 'Telefonnummern-Einstellungen konnten nicht geladen werden', loadError: 'Einstellungen konnten nicht geladen werden. Prüfe Administratorberechtigungen und die API-Antwort.',
        emptyCliList: 'Die Liste der ausgehenden Rufnummern ist leer — prüfe die NoeticaAutodialAdminConfig-Datenbankzeile und ob Migration 122 angewendet wurde.',
        invalidCallerNumber: 'Ungültige Rufnummer', invalidBlocked: 'Ungültige gesperrte Nummer', saveFailed: 'Speichern fehlgeschlagen', serverError: 'Der Server hat einen Fehler zurückgegeben.', saved: 'Telefonnummern-Einstellungen gespeichert',
        invalidCallerNumberDescription: (line: number, value: string) => `Zeile ${line}: Nur Ziffern und ein optionales führendes + sind erlaubt (Beispiel: +4917012345678). Eingabe: "${value}"`,
        invalidBlockedDescription: (line: number, value: string) => `Zeile ${line}: Nur Ziffern, +, -, ( und ) sind erlaubt (Beispiel: +49(170)1234567). Eingabe: "${value}"`,
        description: 'Lege fest, welche Nummern Kunden beim Anruf sehen und welche Nummern der Autodialer niemals wählen soll.',
        lastUpdated: 'Zuletzt geändert am', modifiedBy: 'von',
        callerNumbers: 'Ausgehende Rufnummern',
        callerNumbersDescription: 'Diese Nummer erscheint beim Kunden, wenn er einen Anruf erhält. Der Autodialer durchläuft die Liste der Reihe nach — eine Nummer pro Kunde, der an Noetica gesendet wird. Jede Zeile darf nur Ziffern und ein optionales führendes + enthalten.',
        blockedNumbers: 'Nummern, die niemals angerufen werden',
        blockedNumbersDescription: 'Diese Nummern werden niemals angerufen, auch wenn sie auf einem Kundendatensatz stehen. Jede Zeile darf Ziffern, +, - und Klammern enthalten. Der Abgleich erfolgt nach der Normalisierung auf Ziffern — ein Präfix wie +49 sperrt daher alle Nummern, die mit diesen Ziffern beginnen. Nummern mit fünf oder mehr aufeinanderfolgenden gleichen Ziffern werden automatisch gesperrt.',
        entries: (count: number) => `${count} Einträge`,
        placeholder: 'Nummern aus der Datenbank erscheinen hier nach dem Laden…', save: 'Änderungen speichern',
      },
    },
    reporting: {
      selectTeamBtn: 'Wähle ein Team',
      selectAgentBtn: 'Wähle einen Booker',
      ratingAssignmentPerHour: 'Assignments/Stunde',
      ratingBookings: 'Buchungen',
      ratingBookingsPerHour: 'Buchungen/Stunde',
      ratingSameNextDayBookings: '% Auf Heute/Morgen Gebucht',
      lblPerformanceTrends: 'Assignments pro Booker und Stunde',
      lblDepView: 'Abteilungsübersicht',
      lblTeamView: 'Team-Ansicht',
      clarification: {
        assignments: 'Anzahl an Kunden, die diese Person heute zugewiesen bekommen hat.',
        assignmentsPerHour:
          'Anzahl an Kunden, die diese Person heute zugewiesen bekommen hat, geteilt durch die Arbeitszeit. Die Arbeitszeit ist die Zeit, in der man einen Kunden zugewiesen hatte, multipliziert mit 1.5. Beispiel: 40 Minuten mit zugewiesenem Kunden in BookingOS = 1 Stunde Arbeitszeit. Inbound Center Buchungen und Assignments zählen nicht in diese Metrik.',
        bookings: 'Anzahl an Buchungen heute.',
        bookingsPerHour:
          'Anzahl an Buchungen heute, geteilt durch die Arbeitszeit. Die Arbeitszeit ist die Zeit, in der man einen Kunden zugewiesen hatte, multipliziert mit 1.5. Beispiel: 40 Minuten mit zugewiesenem Kunden in BookingOS = 1 Stunde Arbeitszeit. Inbound Center Buchungen und Assignments zählen nicht in diese Metrik.',
        nearestAppointmentsPerToday: 'Anteil der Buchungen die auf heute oder morgen gelegt wurden. Beispiel: 10 Termine gebucht, davon 4 auf heute oder morgen --> Quote = 40%.',
      },
      viewSwitch: {
        teamView: 'Zur Teamansicht wechseln',
        individualView: 'Zur Einzelansicht wechseln',
      },
      periodSwitch: {
        daily: 'Zur Tagesansicht wechseln',
        monthly: 'Zur Monatsansicht wechseln',
      },
    },

    inboundCenter: {
      assignmentExistsWarning: 'Zuweisung nicht möglich. Bitte schließe zuerst den dir zugewiesenen Kunden ab oder gehe offline, um fortzufahren.',
      assignmentExistsButton: 'Zum zugewiesenen Kunden',
    },

    missingUserProfile: 'Noch keine Kunden bearbeitet. Bitte bearbeite deinen ersten Kunden, um diese Seite zu sehen.',
    profileRemainingXpTillNextLvl: 'Verbleibende XP bis zum nächsten Level:',
    profileTopExperience: 'Bestenliste',
    profileExpHover: `Gebucht - 10 XP
    Nicht erreicht - 1 XP
    Erreicht, aber nicht gebucht - 2 XP
    Kunde verloren - 2 XP
    An Revision gegeben - 2 XP
    Falsche Telefonnummer - 2 XP`,
    getActionName: (action: keyof typeof actionsEn) => {
      return actionsDe[action];
    },

    reportingActivity: 'Aktivität',
    reportingLeadTime: '% Same-/Next-Day Buchungen',
    reportingReachedRate: 'Reached Rate',
    reportingBookings: 'Buchungen',
    reportingBookingRate: 'Buchungsrate',
    reportingShowRate: 'Show Rate',
    reportingNettermine: 'Nettotermine',
    reportingVsYesterday: 'ggü. gestern',
    reportingVsLastMonth: 'ggü. letzten Monat',
    reportingCallPerDay: 'Assignments pro Tag (diesen Monat)',
    reportingCallPerDayPast: 'Assignments pro Tag (letzten Monat)',

    reportingCallPerHour: 'Assignments pro Stunde Heute',
    reportingCallPerHourPast: 'Assignments pro Stunde Gestern',
    reportingTopBookersToday: 'Top Bucher Heute',
    reportingTopCallersToday: 'Top % Same-/Next-Day Buchungen Heute',
    reportingHighestBookingRateToday: 'Meiste Bookings pro Assignment Heute (in %)',
    reportingShowRateLeaderboard: 'Show Rate Heute (in %)',
    reportingComparedToSameTimeYesterday: 'Im Vergleich zur gleichen Zeit gestern',
    reportingComparedToSameTimeLastMonth: 'Im Vergleich zur gleichen Zeit vorigen Monat',
    reportingYourPosition: 'Deine Position',
    reportingWarningMessage: 'Du hast diese Stunde bereits mehr als 3 zugewiesene Kunden zurück in die Warteschlange gegeben, ohne sie zu bearbeiten',
    reportingNextUpdateAt: 'Nächstes Update um',
    reportingNoAppointmentsToday: 'Keine Termine Heute',
    reportingAppointmentsToGo: 'Verbleibende Termine',
    reportingAppointmentsConsidered: 'Berücksichtigte Termine',
    reportingShowRateClarification: 'Es sollten mindestens 3 Termine für den Tag vorhanden sein, die bereits stattgefunden haben, um die Show Rate zu berechnen',
    reportingNotificationCustomerShowed: 'Glückwunsch! Dein gebuchter Termin hat gerade stattgefunden!',
    reportingNotificationCustomerShowedFunc: (slotStartTime: string | undefined, whenBooked: string | null | undefined) => {
      if (!slotStartTime) {
        return 'Glückwunsch! Dein gebuchter Termin hat gerade stattgefunden!';
      }
      return `Glückwunsch! Dein gebuchter Termin hat am ${slotStartTime} Uhr stattgefunden! ${whenBooked ? ` Er hat am ${whenBooked} gebucht` : ''}`;
    },

    reportingNotificationCustomerShowedTitle: 'Kunde zum Termin aufgetaucht!',
    reportingNotificationActionTitle: 'XP erhalten!',
    reportingNotificationAchievementTitle: 'Achievement freigeschaltet!',
    reportingNotificationLevelUp: (level: string | undefined, levelName: string) => {
      return `Du hast jetzt das Level ${level} ${levelName} erreicht`;
    },
    reportingNotificationAchievement: (name: string, points: string) => {
      return `Du hast jetzt das Achievement '${name}' freigeschaltet. ${points} XP erhalten!`;
    },

    planningOnHoldTag: 'Planung pausiert',
    customerPortalCancellation: 'Kunde hat per Inbound oder SST abgesagt',
    planningOnHoldExplanation:
      'Die Planung für diesen Kunden konnte noch nicht abgeschlossen werden, womöglich weil das Haus nicht bei Google Maps gefunden wurde. Der Kunde sollte eine E-Mail von unsere Planungsabteilung erhalten haben, in welcher nach zusätzlichen Infos wie Bauplänen des Hauses gefragt wurde.',
    lostReason: (reason: string) => {
      return englishToGerman[reason];
    },
    inboundCallBack: {
      success: 'Deine Änderungen wurden gespeichert',
      failure: 'Beim Speichern deiner Änderungen ist ein Fehler aufgetreten. Bitte versuche es erneut.',
    },
    cancelAppointment: 'Termin Absagen',
    cancelModal: {
      text: 'Du bist dabei, den Termin endgültig abzusagen. Bist du sicher, dass du fortfahren möchtest?',
      rescheduleInstead: 'Stattdessen Umbuchen',
      confirmCancellation: 'Termin Absagen',
    },
    back: 'Zurück',
    backToInboundCenter: 'Zurück zu Inbound Center',
    reschedule: 'Umbuchen',
    assignToMeAndOpen: 'Mir zuweisen & Öffnen',
    salesAgentManagement: {
      department: 'Abteilung',
      failedToLoad: 'Laden der Vertriebsmitarbeiter fehlgeschlagen',
      modalTitle: 'Vertriebsmitarbeiter Kalender',
      refresh: 'Aktualisieren',
      searchPlaceholder: 'Suche nach Namen',
      tableColumns: {
        id: 'ID',
        name: 'Name',
        salesChannel: 'Vertriebskanal',
        department: 'Abteilung',
        salesLeague: 'Vertriebs Liga',
        zipCodes: 'PLZ',
        lastModified: 'Zuletzt geändert',
        productType: 'Produkttyp',
        paymentModel: 'Zahlungsmodell',
        status: 'Status',
      },
      title: 'Vertriebsmitarbeiter Verwaltung',
      viewInCrm: (crm: string) => `In ${crm} anzeigen`,
      viewSlots: 'Slots anzeigen',
    },
    searchPlaceholder: 'Suchen Sie nach Vorname, Nachname, Telefonnummer, E-Mail oder ID',
    attention: (email: string) => `Achtung! Dieser Kunde ist derzeit ${email} zugewiesen und wird in Kürze angerufen`,
    lastAppointment: (date: string, time: string, salesManager: string) => `Ursprünglicher Termin am ${date} um ${time} mit ${salesManager}`,
    wrongPhoneNumber: {
      title: 'Falsche Telefonnummer',
      prompt: 'Bitte wähle aus, was an der Telefonnummer falsch ist',
      cancel: 'Absagen',
      saveAndOpenNextCase: 'Speichern & Nächsten Fall öffnen',
      saveAndCompleteCase: 'Speichern & Fall abschließen',
      pleaseSpecifyReason: 'Bitte gib einen Grund an',
      buttonClarification: 'Bitte gib einen Grund an um fortzufahren',
      characterLimitReached: '⚠️ Zeichenlimit erreicht (2000/2000)',
      reasons: [
        'Nummer sieht falsch aus (z.B. 000000000 oder 123456789)',
        'Kein Anschluss unter dieser Nummer',
        'Falsche Person (z.B. wenn die Person Enpal nicht kennt)',
        'Andere (bitte unten angeben)',
      ],
    },
    updateWrongPhoneNumber: {
      body: 'Dieser Kontakt hat eine neue Telefonnummer angegeben. Bitte probier den Kunden über die neue Nummer zu erreichen, um fortzufahren.',
      cancel: 'Abbrechen',
      updateWithNewNumber: 'Neue Nummer ist richtig',
      updateWithnewNumberTooltip: 'Die Nummer wird aktualisiert und du gelangst zurück zur Buchungsmaske',
      newNumberIncorrect: 'Neue Nummer ist auch falsch',
      actionIsDisabled: 'Bitte rufe die neue Nummer an, um fortzufahren',
    },

    signedupPeriod: {
      today: 'Heute',
      yesterday: 'Gestern',
      daysAgo: 'Vor {0} Tagen angemeldet',
      weeksAgo: 'Vor {0} Wochen angemeldet',
      monthsAgo: 'Vor {0} Monaten angemeldet',
      moreThan3MonthsAgo: 'Vor mehr als 3 Monaten angemeldet',
    },

    lostPeriod: {
      today: 'Heute gelostet',
      yesterday: 'Gestern gelostet',
      daysAgo: 'Vor {0} Tagen gelostet',
      weeksAgo: 'Vor {0} Wochen gelostet',
      monthsAgo: 'Vor {0} Monaten gelostet',
      moreThan3MonthsAgo: 'Vor mehr als 3 Monaten gelostet',
    },

    recordingInProgress: 'Dieser Anruf wird aufgenommen. Falls der Kunde nicht erreicht wird, wird die Aufnahme automatisch gelöscht.',
    nonStandardSlots: 'Unübliche slots',
    Mo: 'Mo',
    Tu: 'Di',
    We: 'Mi',
    Th: 'Do',
    Fr: 'Fr',
    Sa: 'Sa',
    followingSlotWillBeBooked: 'Folgender Slot wird gebucht',
    date: 'Datum',
    startTime: 'Startzeit',
    endTime: 'Endzeit',
    wouldYouLikeToProceed: 'Möchtest Du fortfahren?',
    errorOccurred: 'Ein Fehler ist aufgetreten.',
    close: 'Schließen',
    bookingSuccessful: 'Buchung erfolgreich!',
    salesManager: 'Sales Manager',
    youCanCloseThisWindow: 'Du kannst dieses Fenster nun schließen.',
    errorCode: 'Fehlercode',
    cancel: 'Abbrechen',
    confirm: 'Bestätigen',
    noSlotsAvailable: 'Für diese Woche sind keine Slots verfügbar',
    errorLoadingSlots: 'Fehler beim Laden der Slots',
    calendarInitialLoadRetry: 'Der neue Lead wird noch synchronisiert. Der Kalender wird in 5 Sekunden erneut geladen ({0}/{1}).',
    tryAgain: 'Erneut versuchen',
    dontCloseModal: 'Schließe oder aktualisiere die Seite nicht während des Ladens',
    customerCannotBeBooked:
      "Bitte überprüfe, ob dieser Kunde bereits einen Termin gebucht hat. Wenn nicht, verwende die alte Schaltfläche 'Verkaufsgespräch planen' in Salesforce für diesen Kunden und melde diesen Fall Deinem Teamleiter.",
    maximEventCountLabel: 'Maximal mögliche Ereignisse für die Buchung, unter Berücksichtigung der maximalen Termine pro Tag und Verkäufer',
    totalEventCountLabel: 'Buchbare Ereignisse insgesamt, ohne Obergrenze',
    totalBookedEventCountLabel: 'Gebuchte Veranstaltungen für den Tag insgesamt',
    from: 'Von',
    to: 'Bis',
    showLogs: 'Logs Anzeigen',
    fromLargerThanTo: 'Von darf nicht größer als Bis sein',
    searchMax3Days: 'Du kannst nur innerhalb von 3 Tagen suchen',
    UnauthorizedAccess: 'Du bist nicht autorisiert auf diese Seite zuzugreifen',
    team: 'Team',
    reason: 'Grund',
    customerTier: 'Kundenrang',
    result: 'Ergebnis',
    status: 'Status',
    rebook: 'Umbuchen',
    time: 'Zeit',
    sellerLanguage: 'Sales Manager Sprache',
    English: 'Englisch',
    German: 'Deutsch',
    referredBy: 'Empfohlen von',
    paymentModel: 'Zahlungsmodell',
    products: 'Produkte',

    SCHEDULING_CASE_NOT_FOUND: 'Dieser Slot/Kunde konnte nicht gebucht werden: Bitte schick den Kundenlink an Deinen TL und Carl Löbbecke und nutze den alten Button in Salesforce zur Buchung.',
    NO_SLOTS_AVAILABLE: 'Dieser Slot ist nicht mehr verfügbar. Bitte versuche es mit einem anderen Zeitfenster.',

    selectAtLeastOneReason: 'Wähle einen Grund aus',
    loadCalendar: 'Kalender Laden',
    startBooking: 'Buchung Starten',
    leadQueueQualification: {
      instructions: 'Bitte stelle dem Kunden die folgenden Fragen, um zum Kalender zu gelangen:',
      next: 'Weiter',
      questionCounter: 'Frage {current} von {total}',
    },
    opportunityCommentsPlaceholder: 'Füge hier Deine Gesprächsnotizen ein. Sie werden automatisch beim Schließen des Falls gespeichert.',
    opportunityCommentsError: 'Zu viele Zeichen',
    saveAndOpenNextCase: 'Speichern & Nächsten Fall öffnen',
    openNextCase: 'Nächsten Fall öffnen',
    modalTextLoadingNextCustomer: 'Nächster Kunde wird geladen...',
    modalTitleReachedNotBooked: 'Erreicht, Aber Nicht Gebucht',
    modalTextReachedNotBookedHoursInAdvance: 'Bitte wähle die Anzahl an Stunden, die wir mindestens warten sollen, bevor wir den Kunden erneut anrufen',
    modalTitleCustomerLost: 'An Revision geben',
    looseCustomerButton: 'Kunde verloren',
    completeCaseButton: 'Fall schließen',
    completeCaseModalTitle: 'Fall schließen',
    completeCaseModalText:
      'Du bist dabei, diesen Fall zu schließen. Wähle den Grund aus, der am besten beschreibt, warum ein Verkaufsgespräch derzeit nicht möglich ist.',
    modalTitleNotReached: 'Nicht Erreicht',
    modalTextNotReached: 'Mit dieser Aktion wird der aktuelle Fall gesnoozed und der nächste Fall geöffnet.',
    notReachedButton: 'Nicht erreicht',
    mailboxButton: 'Mailbox',
    noMailboxButton: 'Keine Mailbox',
    modalTextSelectNewTime: 'Oder wähle die ungefähre Zeit, zu der der Kunde das nächste Mal erreichbar ist:',
    modalTextCustomerLostRevision: 'Hinweis: Du bist im Begriff, den Kunden zu losten. Bitte wähle einen Grund aus, warum ein Verkaufsgespräch mit dem Kunden derzeit nicht durchführbar ist',
    modalTextCustomerLost:
      'Hinweis: Du bist im Begriff, den Kunden an das Revision Team zu geben. Bitte wähle einen Grund aus, warum ein Verkaufsgespräch mit dem Kunden derzeit nicht durchführbar ist',
    customerLostOptions: Object.entries(germanToEnglish).map(([nameOfProp, propValue]) => ({
      value: propValue,
      label: nameOfProp,
    })),
    customerLostPlaceholder: 'Bitte füge hier Deine Kommentare ein...',
    customerLostUpTo3OptionsError: 'Du kannst maximal 1 Grund auswählen',
    customerLostAtLeastOneOptionError: 'Bitte wähle einen Grund aus',
    customerLostTooManyCharactersError: 'Es sind nicht mehr als 255 Zeichen erlaubt.',
    customerLostNoCharactersError: 'Eine Beschreibung, warum der Kunde verloren gegangen ist, ist erforderlich.',

    goOnline: 'Online Gehen',
    goOffline: 'Offline Gehen',
    goOfflineModalText:
      'Dadurch werden alle Änderungen, die Du am aktuellen Fall vorgenommen hast, verworfen und der Fall wird einem anderen Buchungsagenten neu zugewiesen. Bist Du sicher, dass Du fortfahren möchtest?',
    goOnlineModalText: 'Dir wird gleich ein Fall zugewiesen. Bist Du sicher, dass Du fortfahren möchtest?',

    coundownRefreshError: 'Die Dauer der Fallzuweisung kann nur aktualisiert werden, wenn sie weniger als 8 Minuten beträgt',
    countdownRefreshTooltip: 'Aktualisiere die Dauer der Fallzuweisung',
    countdownLessThanAMinuteTitle: 'Weniger als 1 Minute verbleibt für diesen Fall',
    countdownLessThanAMinuteDescription:
      'Nach Ablauf des Timers wird dieser Fall automatisch einer anderen Person zugewiesen. Wenn Du mehr Zeit brauchst, kannst Du den Timer über den Knopf daneben verlängern.',
    salesScript: 'Verkaufsskript',
    objections: 'Einwände',
    appointmentDetails: 'Termindetails',
    openingNextCaseIn: 'Nächster Fall wird in {0}',
    youAreOffline: 'Du bist offline',
    goBackOnlineToReceiveCase: 'Bitte geh wieder online, um einen neuen Fall zu erhalten',
    autodialerMissingId: 'Keine Opportunity-ID angegeben. Verwende einen Link mit id=internalOppId.',
    autodialerAssignFailed: 'Fall konnte nicht zugewiesen werden.',
    autodialerAssignmentExistsOtherCase:
      'Dir ist bereits ein anderer Fall zugewiesen. Schließe oder gib diesen Fall auf der Buchungsseite frei und öffne diesen Autodialer-Link erneut.',
    autodialerCaseNotFound: 'Kein Fall für diesen Link gefunden. Prüfe, ob die id die Booking-OS-InternalId ist (Noetica BOSinternalId), und ob der Fall in dieser Umgebung existiert.',
    autodialerNotAutodialedCase: 'Dieser Fall ist aktuell in keiner Autodialer-Liste. Der Autodialer-Link kann nur Opportunities zuweisen, die als autodialed markiert sind.',
    autodialerNotInAutodialer: 'Dieser Kunde ist nicht mehr im Autodialer. Bitte wende dich an deinen Booking Manager.',
    autodialerCaseComplete: 'Fertig',
    assignmentConflict: {
      title: 'Dir ist bereits ein Kunde zugewiesen',
      body: 'Dir ist weiterhin {0} zugewiesen. Das ist ein anderer Kunde als der, den du gerade geöffnet hast.',
      newCustomerNote: 'Wenn du zum neuen Kunden wechselst, wird der aktuelle Kunde freigegeben.',
      keepOldButton: 'Aktuellen Kunden behalten',
      switchNewButton: 'Zum neuen Kunden wechseln',
      oldCompletedNotReached: 'Der vorherige Kunde wurde freigegeben.',
      completeOldFailed: 'Der vorherige Kunde konnte nicht freigegeben werden. Bitte versuche es erneut.',
      thisCustomer: 'der aktuelle Kunde',
    },
    assignmentChanged: {
      title: 'Deine Zuweisung hat sich geändert',
      body: 'Dieser Kunde ist dir nicht mehr zugewiesen. Aktualisiere die Seite, bevor du fortfährst.',
      refreshButton: 'Seite aktualisieren',
    },
    autodialerHpMissingCrmId: 'Keine CRM-ID angegeben. Verwende einen Link mit crmId.',
    autodialerHpLoadFailed: 'Autodialer-HP-Informationen für diesen Deal konnten nicht geladen werden.',
    autodialerHpForbidden: 'Du hast keine Berechtigung, diesen Deal zu laden. Bitte wende dich an den BookingOS-Administrator, damit er dir die erforderliche Entra-Rolle zuweist.',

    offlinePageTitle: 'Du bist offline',
    offlinePageContent: 'Bitte geh online, um einen neuen Fall zu erhalten.',

    onlinePageNoCasesTitle: 'Es gibt im Moment keine Fälle',
    onlinePageNoCasesContent: 'Erneuter Versuch in ',
    onlinePageNoCaesFetchingNewCase: 'Einen neuen Fall holen..',
    onlinePageNoCasesPleaseDoNotClose: 'Bitte schließe diese Seite nicht.',
    onlinePageNoCasesSeconds: ' Sekunden',
    caseCommentsBtn: (count: number) => `Zeige ${count} vorherige Kommentare`,
    caseCommentsModalTitle: 'Vorherige Kommentare',

    customerInfoCaseCopied: 'Fall in die Zwischenablage kopiert',
    customerInfoFailedToCopy: 'Text konnte nicht kopiert werden',

    share: 'Teilen',
    edit: 'Bearbeiten',

    cancelCountdown: 'Countdown abbrechen',
    toolTipReferrer:
      'Dieser Vertriebsmitarbeiter wurde von einem bestehenden Enpal Kunden empfohlen. Der neue Kunde erhält einen Vertriebstermin mit dem gleichen Mitarbeiter wie der Empfehler, sofern dies möglich ist.',
    toolTipProductType:
      'Dies ist die für den Kunden ausgewählte Produkt- und Finanzierungsart. Der Kunde erhält einen Vetriebstermin mit einem Mitarbeiter, der für den Verkauf aller ausgewählten Produkte geschult ist.',
    toolTipReactivatedCustomer: 'Dieser Kunde wurde über eine interne Kampagne reaktiviert.',
    tooltipCrmKunde:
      'Dieser Kunde wurde kürzlich per Nachricht (E-Mail, SMS, o.ä.) von Enpal kontaktiert und hat das Interesse an einer Enpal Energielösung bestätigt. Möglicherweise war er/sie schon einmal bei uns im Verkaufsprozess.',

    reactivatedCustomer: 'Reaktivierter Kunde',

    caseCompleteNotification: 'Dir wurde ein neuer Fall zugewiesen',

    caseNotFoundErrorDescription: 'Diese Fall ist nicht mehr verfügbar. Womöglich wurde der Kunde außerhalb von BookingOS bearbeitet oder hat sich selbst einen Termin gebucht.',
    youCanGetANewCase: 'Um einen neuen Fall zu erhalten, klicke auf die Schaltfläche unten.',
    genericCloseCaseErrorDescription: 'Beim Schließen dieses Falles ist ein Fehler aufgetreten. Dieser Fehler wurde gespeichert.',
    getNewCase: 'Neuen Fall erhalten',

    voiceMailHint: 'Wenn Du diesen Kunden nicht erreichst, hinterlasse bitte eine Mailbox-Nachricht.',

    assignNewCaseError: 'Zuweisung eines neuen Falls fehlgeschlagen. Bitte versuchen Sie es erneut.',

    bookingStatus: (status: string) => {
      return status === 'FirstTimeScheduling' || status === 'First Time Scheduling' ? 'Erstbuchung' : 'Reterminierung';
    },
    salesChannelDropdownLabel: 'Wähle Deinen Vertriebskanal:',

    noOpportunityInCalendarTitle: 'Kunde nicht gefunden',
    noOpportunityInCalendarMessage:
      'Buchungen für diese Opportunity werden fehlschlagen, da sie entweder geschlossen wurde oder bereits weiter im Verkaufsprozess ist. Bitte stell sicher, dass die Opportunity in Salesforce offen ist und sich in der Buchungsphase befindet',

    customerLostShareDataPlaceholder: 'Hat der Kunde der Kontaktweitergabe an Enpal-Partner zugestimmt?',
    customerLostShareDataEntries: Object.entries(customerLostShareContactDataOptionsDeToEn).map(([nameOfProp, propValue]) => ({
      value: propValue,
      label: nameOfProp,
    })),
    customerLostShareDataLabel: 'Bitte frag den Kunden, ob er mit der Weitergabe seiner Kontaktdaten an einen Enpal Partner einverstanden ist.',
    customerLostShareDataTooltip:
      'Dieser Kunde kann sein Bauvorhaben wahrscheinlich durch einen Enpal Partner realisieren. Indem er seine Zustimmung gibt, können wir ihn mit einem entsprechenden Partner in Verbindung setzen. Bitte achte darauf, dass du die Einverständnis des Kunden auch in Talkdesk aufnimmst.',
    customerLostShareDataNoOptionError: 'Bitte gib an, ob der Kunde der Kontaktweitergabe zustimmt',

    adBookingPage: {
      caseIdLabel: 'BookingOS-Fall-ID',
      signupIdLabel: 'Signup-ID',
      caseNotFound: 'Dieser Fall wurde nicht gefunden.',
      caseAccessDenied: 'Du hast keinen Zugriff auf diesen Fall.',
      caseLoadError: 'Der Fall konnte nicht geladen werden.',
      questionnaireLoadError: 'Der Fragebogen konnte nicht geladen werden.',
      missingCaseId: 'Die BookingOS-Fall-ID fehlt in diesem Link.',
      assignmentExtendError: 'Die Zuweisung konnte nicht verlängert werden.',
      caseReleaseError: 'Der Fall konnte nicht freigegeben werden.',
      caseCloseError: 'Der Fall konnte nicht geschlossen werden.',
      caseReloadError: 'Der Fall konnte nicht erneut geladen werden.',
      currentCaseCompletionError: 'Der aktuelle Fall konnte nicht abgeschlossen werden. Er bleibt dir zugewiesen.',
      caseSwitchError: 'Der Fall konnte nicht gewechselt werden.',
      noConfirmedBooking: 'Es liegt keine bestätigte Buchung zum Abschließen vor.',
      completionError: 'Der Fall konnte nicht abgeschlossen werden. Versuche den Abschluss erneut; die Zeeg-Buchung ist bereits bestätigt.',
      completionRetryError: 'Der Fallabschluss konnte nicht erneut versucht werden.',
      zeegAvailabilityError: 'Die Zeeg-Verfügbarkeit konnte nicht geladen werden.',
      caseNotLoaded: 'Der Fall ist nicht geladen.',
      savedFormLoadError: 'Das gespeicherte Formular konnte nicht geladen werden.',
      savedFormRetryDescription: 'Der Fall bleibt dir zugewiesen. Versuche es erneut, wenn das Formular weiterhin nicht verfügbar ist.',
      bookingCompleted: 'Termin gebucht und Fall abgeschlossen.',
      cancellationCompleted: 'Kunde storniert und Fall abgeschlossen.',
      confirmCancellationDescription: 'Prüfe den Stornogrund und bestätige, um diesen Fall zu schließen.',
      notReachedCompleted: 'Nicht erreicht gespeichert und Fall abgeschlossen.',
      reachedNotBookedCompleted: 'Erreicht, aber nicht gebucht gespeichert und Fall abgeschlossen.',
      canClosePage: 'Du kannst diese Seite jetzt schließen.',
      keepPageOpen: 'Lass diese Seite offen und versuche den Fallabschluss erneut. Der Termin darf nicht erneut gebucht werden.',
      snoozeSummary: (minutes: number, until: string) => `Wiedervorlage in ${minutes} Minuten, am ${until} (Berliner Zeit).`,
      completionPending: 'Der Zeeg-Termin ist bestätigt, aber der Fallabschluss steht noch aus.',
      retryCompletionButton: 'Fallabschluss erneut versuchen',
      videoBookingTitle: 'Videotermin buchen',
      openCaseError: 'Der Fall konnte nicht geöffnet werden',
      lostReasonsTitle: 'Einwände & Schließgründe',
      showMoreReasons: 'Mehr anzeigen',
      showLessReasons: 'Weniger anzeigen',
    },

    preSalesQuestionnaire: {
      cancellationTitle: 'STORNO!',
      cancellationHeatLoadTitle: 'Storno / Heizlast',
      noCancellation: 'Kein Storno',
      cancellationDefaultDescription: 'Die aktuellen Antworten blockieren dieses Formular.',
      showCancellationReasons: 'Stornogründe anzeigen',
      noCancellationReasons: 'Keine Stornogründe',
      cancellationCheckUnavailable: 'Stornoprüfung nicht verfügbar',
      cancellationReasonQuestionsIntro: 'Die Stornogründe liegen vor aufgrund der Antworten zu den folgenden Fragen:',
      cancellationEvaluationError: 'Die Stornierung konnte nicht geprüft werden. Ändere eine Antwort oder versuche es vor dem Absenden erneut.',
      productOverviewTitle: 'Produktübersicht',
      heatPumpShortLabel: 'WP',
      pvShortLabel: 'PV',
      productStatusNotInterested: 'Kein Interesse',
      productStatusEligible: 'Geeignet',
      productStatusPending: 'Qualifizierung ausstehend',
      productStatusNotEligible: 'Nicht geeignet',
      showReasons: 'Stornogründe anzeigen',
      productCancellationReasonsTitle: (product: string) => `Stornogründe: ${product}`,
      questionnaireProgress: 'Fragebogen-Fortschritt',
      questionnaireProgressSummary: (answered: number, total: number, percent: number) =>
        `${answered} von ${total} Feldern beantwortet · ${percent}%`,
      dealInfoTitle: 'Deal-Info',
      dealIdLabel: 'Deal ID',
      hpOrderNumberLabel: 'HP Order Number',
      customerLabel: 'Kundenname',
      addressLabel: 'Adresse',
      emailLabel: 'E-Mail',
      heatLoadLabel: 'Heizlast',
      heatLoadReady: 'Heizlast bereit',
      heatLoadValid: 'Heizlast in Ordnung',
      heatLoadCancellation: 'Heizlast Storno',
      heatLoadProgressLabel: (percent: number) => `Vollständigkeit der Heizlastangaben, ${percent}%`,
      showHeatLoadInformation: 'Informationen zur Heizlast anzeigen',
      showFaqInformation: 'FAQ-Informationen anzeigen',
      saveButton: 'Speichern',
      saveSuccess: 'Pre-Sales-Formular gespeichert',
      saveError: 'Pre-Sales-Formular konnte nicht gespeichert werden',
      saveMissingIdentifier: 'Pre-Sales-Formular kann ohne CRM-ID nicht gespeichert werden',
      submitButton: 'Absenden',
      backToFormButton: 'Zurück zum Formular',
      closeCaseButton: 'Fall schließen',
      closeCaseTooltip: 'Ein Klick hierauf schließt den Fragebogen und stoppt die Aufnahme. Du kannst die Seite neu laden, um erneut zu starten.',
      closeCaseSuccess: 'Fall geschlossen',
      submitSuccess: 'Pre-Sales-Formular gesendet',
      submitError: 'Pre-Sales-Formular konnte nicht gesendet werden',
      submitMissingIdentifier: 'Pre-Sales-Formular kann ohne CRM-ID nicht gesendet werden',
      submitValidationError: 'Bitte fülle die erforderlichen Pre-Sales-Fragen vor dem Absenden aus',
      pvQualifiedTitle: 'Weiter zur Kombi-Übergabe',
      pvQualifiedDescription: 'Mit der Bestätigung wird der PV-Lead für das kombinierte PV- und Wärmepumpenangebot erstellt und weitergeleitet. Anschließend wählst du einen Termin aus.',
      pvOnlyQualifiedTitle: 'Weiter zur PV-Übergabe',
      pvOnlyQualifiedDescription: 'Mit der Bestätigung wird der PV-Lead erstellt und weitergeleitet. Anschließend wählst du einen Termin aus.',
      combiHandoverNextStep: 'Als Nächstes: Übergabe an Kombi',
      pvHandoverNextStep: 'Als Nächstes: Übergabe an PV',
      pvQualifiedAbortDescription: 'Bei einem Abbruch geht der TMVT mit der nächsten Frage weiter.',
      combiForwardButton: 'Weiter zur Kombi-Übergabe',
      pvForwardButton: 'Weiter zur PV-Übergabe',
      pvDeclineButton: 'Abbrechen',
      pvConfigurationError: 'PV-Übergabe ist nicht verfügbar',
      pvMissingSignupId: 'Die PV-Übergabe ist nicht verfügbar, weil dem aktuellen Lead die Signup-ID fehlt.',
      pvMissingGcId: 'Die PV-Übergabe ist nicht verfügbar, weil dem aktuellen Kunden die GCID fehlt.',
      pvDisqualifiedTitle: 'PV Disqualifiziert',
      pvDisqualifiedDescription: 'Leider können wir dem Kunden keine PV-Anlage anbieten. Bitte fahre mit dem TMVT fort.',
      pvOnlyDisqualifiedDescription: 'Leider können wir dem Kunden keine PV-Anlage anbieten. Da der Kunde ausschließlich an PV interessiert ist, sende das Formular regulär ab, um den Wärmepumpen-Lead als verloren zu markieren.',
      pvContinueHeatButton: 'Bestätigen',
      pvForwardingError: 'PV-Übergabe fehlgeschlagen',
      leadAlreadyHandedOver: 'Der Lead wurde erfolgreich übergeben. Ein Booker wird den Kunden erneut anrufen, um den Termin zu vereinbaren.',
      pvHandoverMissingResult: 'Lead Handling hat keine Signup-ID für den neuen PV-Lead zurückgegeben. Bitte wiederhole die Übergabe.',
      pvForwardingSuccessTitle: 'PV-Lead erstellt',
      pvHandoverCalendarDescription: 'Wähle einen Digital-Sales-Termin für den neuen PV-Lead aus.',
      combiForwardingSuccessTitle: 'Kombi-Übergabe bereit',
      combiHandoverCalendarDescription: 'Wähle einen Digital-Sales-Termin für den neuen Kombi-Lead aus.',
      pvBookingSuccessTitle: 'PV-Buchung erfolgreich',
      combiBookingSuccessTitle: 'Kombi-Buchung erfolgreich',
      resultCancellationTitle: 'Storno',
      resultCancellationDescription: 'Leider können wir keine Wärmepumpe anbieten. Die folgenden Stornogründe wurden zurückgegeben:',
      resultCancellationNoReasons: 'Leider können wir keine Wärmepumpe anbieten. Es wurden keine konkreten Stornogründe zurückgegeben.',
      resultBuildableTitle: 'Keine Stornogründe gefunden',
      fieldSalesChoiceQuestion: 'Möchte der Kunde einen Field-Sales-Termin?',
      fieldSalesMissingZipCode: 'Field-Sales-Kalender kann ohne Postleitzahl nicht geladen werden',
      fieldSalesAvailabilityError: 'Field-Sales-Verfügbarkeit konnte nicht geladen werden',
      fieldSalesAvailabilityChecking: 'Field-Sales-Verfügbarkeit wird geprüft…',
      fieldSalesChoiceUnavailable: 'Field-Sales-Buchung ist für diesen Kunden nicht verfügbar.',
      fieldSalesCalendarTitle: 'Field-Sales-Verfügbarkeit',
      fieldSalesUnavailable: 'Für diese Postleitzahl ist kein Field-Sales-Agent verfügbar',
      fieldSalesSlotsError: 'Field-Sales-Termin-Slots konnten nicht geladen werden',
      fieldSalesBookingError: 'Field-Sales-Termin konnte nicht gebucht werden',
      fieldSalesBookingConfirmationError: 'Der Slot wurde gebucht, aber die Field-Sales-Buchung konnte nicht bestätigt werden',
      fieldSalesConfirmationError: 'Field Sales konnte nicht bestätigt werden',
      fieldSalesConfirmationMissingDeal: 'Field Sales kann ohne Deal-ID nicht bestätigt werden',
      fieldSalesBookingMissingData: 'Field-Sales-Termin kann ohne Deal, Postleitzahl und Slot nicht gebucht werden',
      fieldSalesBookingSuccess: 'Field-Sales-Termin gebucht',
      fieldSalesBookingSuccessTitle: 'Field-Sales-Buchung erfolgreich',
      bookingConfirmationPending: 'Ein Termin wurde bereits erstellt und muss noch bestätigt werden. Wiederhole dieselbe Buchung, bevor du den Vertriebskanal wechselst.',
      videoCalendarTitle: 'Video-Termin-Slots',
      videoCalendarSwitchLabel: 'Kalenderauswahl',
      videoCalendarSwitchDescription: 'Zwischen zwei Termin-Kalendern wechseln.',
      videoPrimaryCalendarLabel: 'Primärer Kalender',
      videoDefaultCalendarLabel: 'Standardkalender',
      videoPrimaryCalendarPosition: 'Primär · 1 / 2',
      videoDefaultCalendarPosition: 'Standard · 2 / 2',
      videoSlotsError: 'Video-Termin-Slots konnten nicht geladen werden',
      videoSlotsEmpty: 'Für diese Woche sind keine Video-Termin-Slots verfügbar',
      videoSlotBookButton: 'Buchen',
      videoSlotBookedButton: 'Gebucht',
      videoBookingSuccess: 'Video-Termin gebucht',
      videoBookingSuccessTitle: 'SC1-Buchung erfolgreich',
      videoBookingError: 'Video-Termin konnte nicht gebucht werden',
      videoBookingConfirmationError: 'Der Zeeg-Termin wurde gebucht, aber der Deal konnte nicht als Video Sales abgeschlossen werden',
      videoBookingMissingContact: 'Video-Termin kann ohne Name und E-Mail nicht gebucht werden',
      videoBookingMissingDeal: 'Video-Termin kann ohne gültige Deal-ID nicht gebucht werden',
      videoBookingConfigurationError: 'Video-Buchung ist nicht verfügbar, da die Zeeg-Routing-Informationen fehlen',
      whatsAppTipTitle: 'Tipp für den Kunden',
      whatsAppTipDescription: 'Für eine reibungslose Kundenreise empfehlen wir, uns die Kommunikation über WhatsApp zu erlauben. Dafür müssen Sie in der Bestätigungsmail nur einmal auf den Link klicken.',
      customerPortalTipTitle: 'Hinweis auf das Kundenportal',
      customerPortalTipDescription: 'Bitte weise den Kunden darauf hin, dass sie mit der Bestätigungsmail eine Einladung in unser Kundenportal erhalten. Dort können Kunden:',
      customerPortalTipBenefits: [
        'Ihre nächsten Termine einsehen',
        'Den Beratungsprozess verfolgen',
        'Ihre Antworten aus diesem Telefonat noch einmal überprüfen',
      ],
      meetingUrlLabel: 'Meeting-URL',
      bookingIdLabel: 'Buchungs-ID',
      yesButton: 'Ja',
      noButton: 'Nein',
    },

    contactEditTitle: 'Kontaktdaten bearbeiten',
    contactEditCancel: 'Abbrechen',
    contactEditSave: 'Speichern',
    contactEditSalutation: 'Anrede',
    contactEditFirstName: 'Vorname',
    contactEditLastName: 'Nachname',
    contactEditPhone: 'Telefonnummer',
    contactEditAddress: 'Adresse',
    contactEditStreet: 'Straße',
    contactEditHouseNumber: 'Hausnummer',
    contactEditZipCode: 'Postleitzahl',
    contactEditCity: 'Stadt',
    contactEditConvertToAreaCode: '+49 Vorwahl einfügen',
    contactEditEditInSalesforce: 'Adresse bearbeiten',
    contactEditNamesInSalesforce: 'Namen bearbeiten',
    customerLostDataDeletion: 'Datenlöschung',
    customerLostConfirmEmailSent: 'E-Mail an Datenschutz versendet',
    customerLostDataDeletionProceedToolTip: 'Bitte bestätige, dass du eine E-Mail zur Datenlöschung an das Datenschutz-Team gesendet hast.',
    customerLostDataDeletionButtonToolTip: 'Erstellt einen E-Mail Entwurf an das Datenschutzteam zur Datenlöschung dieses Kundens. Du kannst den Entwurf vor dem Absenden bearbeiten.',

    customerJourneyPlanner: {
      summary: 'Lege fest, wie BookingOS mit Leads umgeht.',
      ruleOrderHelp: 'So funktioniert die Regelausführung',
      ruleOrderHelpContent: 'Regeln werden in alphabetischer Reihenfolge ausgeführt. Stelle dem Regelnamen eine Zahl voran, um die Ausführungsreihenfolge festzulegen.',
      moreActions: 'Weitere Aktionen',
      descriptionLine1: 'Ändere, wie Leads in BookingOS behandelt werden. Verwende Regeln, um Qualifizierungsabläufe, Skripte, Buchungsverhalten und andere kundenseitige Aktionen anzupassen. Regeln werden in alphabetischer Reihenfolge ausgeführt – füge dem Regelnamen eine Zahl voran, um die Ausführungsreihenfolge festzulegen.',
      descriptionLine2: 'Bewege den Mauszeiger über das ⓘ neben einem Regelnamen, um die Beschreibung zu lesen.',
      filterOutcome: 'Ergebnis',
      filterCondition: 'Bedingung',
      filterSalesChannel: 'Vertriebskanal',
      outcomeOpportunitySync: 'Opp-Sync',
      outcomeCalendarDisplay: 'Kalenderanzeige',
      outcomeSlotBooking: 'Slot-Buchung',
      outcomeAgentsView: 'Skripte',
      filterPlaceholder: 'Ergebnis',
      filterByOutcome: 'Nach Ergebnis filtern',
      filterBySalesChannel: 'Nach Vertriebskanal filtern',
      clearAll: 'Alle löschen',
      searchPlaceholder: 'Regeln durchsuchen, z.B. nach Leadquelle',
      searchTooltip: 'Nach Regelname, Bedingung oder Ergebnis suchen',
      addRuleLabel: 'Neue Regel',
      addRuleDescription: 'Erstelle eine bedingungsbasierte Regel, um festzulegen, wie Leads behandelt werden.',
      exportRules: 'Regeln exportieren',
      importRules: 'Regeln importieren',
      loadFailed: 'Fehler beim Laden der Regeln',
      loadFailedDescription: 'Das Laden der Regeln ist fehlgeschlagen.',
      savedSuccessfully: 'Regel erfolgreich gespeichert',
      saveFailed: 'Fehler beim Speichern der Regel',
      unknownError: 'Unbekannter Fehler',
      edit: 'Bearbeiten',
      duplicate: 'Duplizieren',
      delete: 'Löschen',
      duplicateSuffix: 'KOPIE',
      ruleActions: 'Regelaktionen',
      resultsCount: '{count} von {total} Regeln',
      noRulesMatched: 'Keine Regeln entsprechen deiner Suche oder deinem Filter.',
      by: 'Von',
      modified: 'Geändert',
      deleteConfirmTitle: 'Sicher, dass du diese Regel löschen möchtest?',
      deleteConfirmContent: 'Diese Aktion kann nicht rückgängig gemacht werden.',
      deleteConfirmOk: 'Ja',
      deleteConfirmCancel: 'Nein',
    },

    // 404 Page
    pageNotFound: {
      title: 'Seite nicht gefunden',
      message: 'Die Seite, die Sie suchen, existiert nicht.',
      goToBooking: 'Zur Buchung',
      errorCode: 'Fehler 404',
    },

    // Access Denied Page
    accessDenied: {
      title: 'Zugriff verweigert',
      message: 'Sie haben keine Berechtigung, auf diese Seite zuzugreifen. Bitte wenden Sie sich an Ihren Administrator, wenn Sie glauben, dass dies ein Fehler ist.',
      goToBooking: 'Zur Buchung',
    },
  },
});

/** Persisted language preference key. Shared with the header language selector. */
export const LANGUAGE_STORAGE_KEY = 'language';

/**
 * Initial UI language: a previously stored preference if valid, otherwise German.
 * localStorage persists across tabs and reloads; access is guarded for private mode.
 */
const getInitialLanguage = (): string => {
  try {
    const saved = localStorage.getItem(LANGUAGE_STORAGE_KEY);
    if (saved === 'de' || saved === 'en') {
      return saved;
    }
  } catch {
    // Ignore localStorage access errors and fall back to the default.
  }
  return 'de';
};

const initialLanguage = getInitialLanguage();
strings.setLanguage(initialLanguage);
try {
  document.documentElement.lang = initialLanguage;
} catch {
  // No document (e.g. non-browser env); nothing to set.
}
